export enum Channel {
  NAVER_MAP = "NAVER_MAP",
  NAVER_CAFE = "NAVER_CAFE",
  NAVER_BLOG = "NAVER_BLOG",
  KAKAO_MAP = "KAKAO_MAP",
  GOOGLE_MAP = "GOOGLE_MAP",
  MODOODOC = "MODOODOC",
  REVIEW_BOOST = "REVIEW_BOOST",
  GANGNAM_SISTER_MAP = "GANGNAM_SISTER_MAP",
  GANGNAM_SISTER_COMMUNITY = "GANGNAM_SISTER_COMMUNITY",
  BABITALK_FREETALK = "BABITALK_FREETALK",
  BABITALK_BALPOOM = "BABITALK_BALPOOM",
  BABITALK_SISOOL = "BABITALK_SISOOL",
  YEOSHIN_TICKET = "YEOSHIN_TICKET",
  YOUTUBE = "YOUTUBE",
  CARROT_MARKET_STORE = "CARROT_MARKET_STORE",
}

export const ChannelColorMap: Record<Channel, string> = {
  [Channel.NAVER_MAP]: "#03C75A",
  [Channel.NAVER_CAFE]: "#03C75A",
  [Channel.NAVER_BLOG]: "#03C75A",
  [Channel.KAKAO_MAP]: "#FEE500",
  [Channel.GOOGLE_MAP]: "#87CEEB",
  [Channel.MODOODOC]: "#9B59B6",
  [Channel.REVIEW_BOOST]: "#95A5A6",
  [Channel.GANGNAM_SISTER_MAP]: "#FF8C00",
  [Channel.GANGNAM_SISTER_COMMUNITY]: "#FF8C00",
  [Channel.BABITALK_FREETALK]: "#9B59B6",
  [Channel.BABITALK_BALPOOM]: "#9B59B6",
  [Channel.BABITALK_SISOOL]: "#9B59B6",
  [Channel.YEOSHIN_TICKET]: "#FF69B4",
  [Channel.YOUTUBE]: "#FF0000",
  [Channel.CARROT_MARKET_STORE]: "#FF8C00",
}
